<script lang="ts">
	import SectionHeadline from './SectionHeadline.svelte';
	export let text: string;
	export let alignment: 'left' | 'center' | 'right' = 'left';
</script>

<SectionHeadline class="content-module-padding text-{alignment}" {...$$restProps}>
	{text}
</SectionHeadline>
